// Rótulos em português para o log de auditoria (tela AuditLog).

const ROTULOS_DE_ACAO: Record<string, string> = {
  credential_used: 'Uso de Credencial',
  credential_viewed: 'Visualização de Credencial',
  credential_created: 'Criação de Credencial',
  credential_updated: 'Atualização de Credencial',
  credential_deleted: 'Deleção de Credencial',
  // Etapa 05: a extensão não conseguiu preencher uma página.
  autofill_failed: 'Falha de preenchimento',
  // Etapa 07 (decisão D16): resultado do botão "Abrir já logado".
  autologin_finished: 'Abrir já logado',
  // Etapa 18: regras de acesso (horário, rede, sites bloqueados).
  access_denied_by_policy: 'Uso bloqueado pelas regras de acesso',
  access_policy_updated: 'Regras de acesso alteradas',
  // Etapas 14 e 16 (D23 traduz): certificados A1 e assinatura de PDF.
  certificate_uploaded: 'Cadastro de Certificado',
  certificate_updated: 'Atualização de Certificado',
  certificate_revoked: 'Certificado removido do Lictor',
  certificate_access_granted: 'Acesso a Certificado concedido',
  certificate_access_revoked: 'Acesso a Certificado removido',
  document_signed: 'Assinatura de PDF',
};

// Etapa 18: motivo do bloqueio (backend/app/services/access_policy.py, MENSAGENS_DE_BLOQUEIO).
const ROTULOS_DO_BLOQUEIO: Record<string, string> = {
  hours: 'Fora do horário permitido',
  ip: 'Fora da rede permitida',
  domain: 'Site bloqueado',
};

// Resultados do "Abrir já logado" (backend/app/schemas/extension_event.py, ResultadoDoAutologin).
const ROTULOS_DE_RESULTADO: Record<string, string> = {
  logged_in: 'entrou',
  needs_user: 'precisa completar',
  failed: 'não entrou',
};

// Eventos da extensão que trazem host e caminho da página nos metadados.
const EVENTOS_DA_EXTENSAO = new Set(['autofill_failed', 'autologin_finished']);

// Motivos aceitos pelo backend em /extension/events (backend/app/schemas/extension_event.py).
const ROTULOS_DE_MOTIVO: Record<string, string> = {
  no_fields_found: 'Nenhum campo de login encontrado na página',
  login_field_not_found: 'Campo de login não encontrado',
  password_field_not_found: 'Campo de senha não encontrado',
  totp_field_not_found: 'Campo do código 2FA não encontrado',
  submit_not_found: 'Botão de entrar não encontrado',
  captcha_detected: 'CAPTCHA na página (envio automático cancelado)',
  inject_error: 'Erro inesperado ao preencher',
  catalog_host_without_credential: 'Tribunal do catálogo sem credencial cadastrada',
  // Etapa 13: o código de 2FA por e-mail não chegou em 90 s.
  mfa_code_timeout: 'O código de verificação do e-mail não chegou',
};

export function traduzirAcao(action: string): string {
  return ROTULOS_DE_ACAO[action] || action;
}

/** Motivo desconhecido (de uma versão futura) aparece como veio, sem quebrar a tela. */
export function traduzirMotivo(reason: string): string {
  return ROTULOS_DE_MOTIVO[reason] || reason;
}

function textoOuNull(valor: unknown): string | null {
  return typeof valor === 'string' && valor ? valor : null;
}

/**
 * Segunda linha da coluna "Ação": falha de preenchimento → "host · motivo"; "Abrir já logado" →
 * "host · resultado · motivo" (o motivo só quando veio); uso bloqueado pelas regras de acesso →
 * "motivo" ou "Site bloqueado · host". Outras ações: null.
 */
export function detalheDaAcao(action: string, metadata: Record<string, unknown> | null | undefined): string | null {
  // Etapa 18: "motivo" (e o site, quando o motivo é site bloqueado).
  if (action === 'access_denied_by_policy') {
    const motivo = textoOuNull(metadata?.reason);
    const partes = [motivo ? ROTULOS_DO_BLOQUEIO[motivo] || motivo : null, textoOuNull(metadata?.page_host)].filter(Boolean);
    return partes.length > 0 ? partes.join(' · ') : null;
  }
  if (!EVENTOS_DA_EXTENSAO.has(action)) return null;
  const host = textoOuNull(metadata?.page_host);
  const motivo = textoOuNull(metadata?.reason);
  const resultado = action === 'autologin_finished' ? textoOuNull(metadata?.outcome) : null;
  const partes = [
    host,
    resultado ? ROTULOS_DE_RESULTADO[resultado] || resultado : null,
    motivo ? traduzirMotivo(motivo) : null,
  ].filter(Boolean);
  return partes.length > 0 ? partes.join(' · ') : null;
}

/** Texto do tooltip: o caminho da página (sem query), quando o evento tem um. */
export function caminhoDaAcao(action: string, metadata: Record<string, unknown> | null | undefined): string | undefined {
  if (!EVENTOS_DA_EXTENSAO.has(action)) return undefined;
  const host = textoOuNull(metadata?.page_host);
  const caminho = textoOuNull(metadata?.page_path);
  return host && caminho ? `${host}${caminho}` : undefined;
}
